// extracted by mini-css-extract-plugin
module.exports = {"minimalTable":"table_minimalTable__lXnlY","hover":"table_hover__1osJ6"};